import './MusicSettings.css'
import React, { useState } from 'react'
import axios from 'axios'
import { useEffect } from 'react';
import { toast } from "react-toastify"
import Response_Processing from '../../../layout/Others/Response_Processing';
import AdminSaveHeader from '../../../components/CommonComponents/AdminSaveHeader';
import FormContainer from '../../../components/CommonComponents/FormContainer';
import LeftWrapper from '../../../components/CommonComponents/LeftWrapper';
import Wrapper from '../../../components/CommonComponents/Wrapper';
import MessageHeading from '../../../components/CommonComponents/MessageHeading';
import AdminSwitch from '../../../components/CommonComponents/AdminSwitch';
import MessageLabel from '../../../components/CommonComponents/MessageLabel';
import RightWrapper from '../../../components/CommonComponents/RightWrapper';
import AdminCustomButton from '../../../components/CommonComponents/AdminCustomButton';
const MusicSettings = () => {
    const access_token = localStorage.getItem("access_token");
    const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + access_token,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
    };
    const [musicData, setMusicData] = useState();
    const [showOverlay, setShowOverlay] = useState(false);
    const [domLoaded, setDomLoaded] = useState(false)

    const handleCheckBox = (e) => {
        if (e.target.checked == true) {
            setMusicData({ ...musicData, [e.target.name]: 1 });
        } else {
            setMusicData({ ...musicData, [e.target.name]: 0 });
        }
    };

    const handleCheckBoxLayout = (e) => {
        const { name } = e.target;
        const propertyToUpdate = name === 'enable_embed' ? 'enable_floating' : 'enable_embed';
        const newValue = e.target.checked ? 1 : 0;

        setMusicData((prevEditUser) => ({
            ...prevEditUser,
            [name]: newValue,
            [propertyToUpdate]: 0
        }));
    }

    const fetchData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Baseurl}/admin/music_setting/index`, { headers: headers });
            setMusicData(response.data.Music_Setting);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleSubmit = async () => {
        try {
            setShowOverlay(true)
            const response = await axios.post(`${process.env.REACT_APP_Baseurl}/admin/music_setting/store`, musicData, { headers: headers });
            if (response.status) {
                setDomLoaded(!domLoaded)
                setShowOverlay(false)
                toast.success(response.data.message)
            }
        } catch (error) {
            setShowOverlay(false)
            console.error("Error fetching data:", error);
        }
    }

    useEffect(() => {
        fetchData()
    }, [domLoaded])


    return (

        <>
            {showOverlay && (<Response_Processing />)}
            <AdminSaveHeader heading={" Music Settings"} saveText={"Update Music"} saveMethod={handleSubmit} />

            <FormContainer>
                <LeftWrapper>
                    <Wrapper>
                        <MessageHeading text={"Choose layout"} />
                        <div className='d-flex align-items-center justify-content-start gap-3 mt-3'>
                            <div className={` p-2 rounded-2 position-relative  ${musicData?.enable_embed ? 'border border-primary activeTrack' : ''}`} >
                                <input type="checkbox" name="enable_embed" className='opacity-0 layoutCheckbox' onChange={handleCheckBoxLayout} checked={musicData?.enable_embed} />
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" style={{ width: '100px', height: "100px", fill: `${musicData?.enable_embed ? '#0d6efd' : '#eee'}` }}><path fill-rule="evenodd" d="M20 27.035a2 2 0 0 0-2 2v12.41a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2v-12.41a2 2 0 0 0-2-2H20Zm10.812 3.572a.5.5 0 0 0-.765.424v3.73a.5.5 0 0 0 .765.423l2.983-1.864a.5.5 0 0 0 0-.848l-2.983-1.865Zm5.177 1.295a.5.5 0 0 1 .765-.424l.752.47v-.046a.5.5 0 0 1 .765-.424l1.57.981a.5.5 0 0 1 0 .848l-1.57.981a.5.5 0 0 1-.765-.424v-.046l-.752.47a.5.5 0 0 1-.765-.424v-1.962Zm-10.752 2.386a.5.5 0 0 0 .765-.424v-.038l.74.462a.5.5 0 0 0 .764-.424v-1.962a.5.5 0 0 0-.765-.424l-.739.462v-.038a.5.5 0 0 0-.765-.424l-1.57.981a.5.5 0 0 0 0 .848l1.57.981ZM21 39.946a.5.5 0 0 1 .5-.5h21a.5.5 0 1 1 0 1h-21a.5.5 0 0 1-.5-.5Z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M60 11a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v42a4 4 0 0 0 4 4h48a4 4 0 0 0 4-4V11ZM6 13h52v40l-.005.15A2 2 0 0 1 56 55H8l-.15-.005A2 2 0 0 1 6 53V13Zm5-2.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm-4 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm8 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z" clip-rule="evenodd"></path></svg>
                                <MessageLabel text={"Embed"} />
                            </div>
                            <div className={`p-2  rounded-2  position-relative ${musicData?.enable_floating ? 'border border-primary activeTrack' : ''} `} onClick={handleCheckBox}>
                                <input type="checkbox" name="enable_floating" className='opacity-0 layoutCheckbox' onChange={handleCheckBoxLayout} checked={musicData?.enable_floating} />
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" style={{ width: '100px', height: "100px", fill: `${musicData?.enable_floating ? '#0d6efd' : '#eee'}` }}><path fill-rule="evenodd" d="M57.068 44h-50v9a1 1 0 0 0 1 1h48a1 1 0 0 0 1-1v-9Zm-40.256 2.607a.5.5 0 0 0-.765.424v3.73a.5.5 0 0 0 .765.423l2.983-1.864a.5.5 0 0 0 0-.848l-2.983-1.865Zm5.177 1.295a.5.5 0 0 1 .765-.424l.752.47v-.046a.5.5 0 0 1 .765-.424l1.57.981a.5.5 0 0 1 0 .848l-1.57.981a.5.5 0 0 1-.765-.424v-.046l-.752.47a.5.5 0 0 1-.765-.424v-1.962Zm-10.752 2.386a.5.5 0 0 0 .765-.424v-.038l.74.462a.5.5 0 0 0 .764-.424v-1.962a.5.5 0 0 0-.765-.424l-.739.462v-.038a.5.5 0 0 0-.765-.424l-1.57.981a.5.5 0 0 0 0 .848l1.57.981ZM30 48.946a.5.5 0 0 1 .5-.5h22a.5.5 0 0 1 0 1h-22a.5.5 0 0 1-.5-.5Z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M60 11a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v42a4 4 0 0 0 4 4h48a4 4 0 0 0 4-4V11ZM6 13h52v40l-.005.15A2 2 0 0 1 56 55H8l-.15-.005A2 2 0 0 1 6 53V13Zm5-2.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm-4 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm8 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z" clip-rule="evenodd"></path></svg>
                                <MessageLabel text={"Floating"} />

                            </div>
                        </div>
                        {musicData?.enable_floating ?
                            <>
                                <div className="d-flex justify-content-between mb-2 ">
                                    <div className="col-6 col-md-6 pe-2">
                                        <MessageLabel text={"Minimize Button"} />
                                    </div>
                                    <div className="col-6 col-md-6 ps-2 text-end">
                                        <AdminSwitch name={'enable_minimize_button'} checked={musicData?.enable_minimize_button == 1} onChange={handleCheckBox} />
                                    </div>
                                </div>
                            </> : ''
                        }
                    </Wrapper>
                    <Wrapper>
                        <MessageHeading text={"Player Controls"} />
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={"Track Controls"} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch name={'enable_track_controls'} checked={musicData?.enable_track_controls == 1} onChange={handleCheckBox} />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={"Volume"} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch name={'enable_volume'} checked={musicData?.enable_volume == 1} onChange={handleCheckBox} />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={"Loop"} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch name={'enable_loop'} checked={musicData?.enable_loop == 1} onChange={handleCheckBox} />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={"Shuffle"} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch name={'enable_shuffle'} checked={musicData?.enable_shuffle == 1} onChange={handleCheckBox} />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={"Progress Bar"} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch name={'enable_progress_bar'} checked={musicData?.enable_progress_bar == 1} onChange={handleCheckBox} />
                            </div>
                        </div>
                    </Wrapper>
                </LeftWrapper>
                <RightWrapper>
                    <Wrapper>
                        <MessageHeading text={"Playlist Default"} />
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={"Show Playlist by Default"} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch name={'enable_show_playlist'} checked={musicData?.enable_show_playlist == 1} onChange={handleCheckBox} />
                            </div>
                        </div>
                    </Wrapper>
                    <Wrapper>
                        <MessageHeading text={"Playlist Info to Display"} />
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={"Image"} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch name={'enable_playlist_image'} checked={musicData?.enable_playlist_image == 1} onChange={handleCheckBox} />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={"Title"} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch name={'enable_playlist_title'} checked={musicData?.enable_playlist_title == 1} onChange={handleCheckBox} />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={"Artists"} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch name={'enable_playlist_artists'} checked={musicData?.enable_playlist_artists == 1} onChange={handleCheckBox} />
                            </div>
                        </div>
                    </Wrapper>
                     <Wrapper>
                        <MessageHeading text={"Track Info to Display"} />
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={"Image"} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch name={'enable_track_image'} checked={musicData?.enable_track_image == 1} onChange={handleCheckBox} />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={"Title"} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch name={'enable_track_title'} checked={musicData?.enable_track_title == 1} onChange={handleCheckBox} />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={"Artists"} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch name={'enable_track_artists'} checked={musicData?.enable_track_artists == 1} onChange={handleCheckBox} />
                            </div>
                        </div>

                    </Wrapper>
                </RightWrapper>
                <AdminCustomButton saveMethod={handleSubmit} type="submit" saveText={"Update Music"} className="ms-auto" loading={showOverlay} />
            </FormContainer>
        </>
    )
}

export default MusicSettings